import React, {Component} from 'react';
import { List, ListGroupItem, Badge } from 'reactstrap';

class PlaceDescItem extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return(
            <ListGroupItem
                className="place-item justify-content-between"
                onClick={() => this.props.onDescriptionClick(this, this.props.placeId, this.props.latLng)}
            >
                {this.props.name} <Badge pill>{this.props.address}</Badge>
            </ListGroupItem>
		)
	}
}

export default PlaceDescItem;
